import * as yup from 'yup';
import { EmailSchema } from 'common/validation-schemas/Common.schema';

export const ForgotPasswordSchema = yup.object({
  email: EmailSchema,
});
